import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const DEFAULT_STATS = [
  { key: 'total', label: 'Total Members', value: 0 },
  { key: 'admins', label: 'Admins', value: 0 },
  { key: 'members', label: 'Members', value: 0 },
  { key: 'totalPurchases', label: 'Total Purchases', value: 0 },
  { key: 'banned', label: 'Banned', value: 0 },
];

function HeaderOverview({ stats = DEFAULT_STATS, onInvite, canManage = false }) {
  return (
    <div className="members-header-overview">
      {/* HEADER */}
      <div className="page-header">
        <div>
          <div className="page-title">Members</div>
          <div className="page-subtitle">
            Manage group members, permissions and invitations
          </div>
        </div>

        {canManage && (
          <div className="header-actions">
            <button type="button" className="btn-outline" onClick={onInvite}>
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="8.5" cy="7" r="4" />
                <line x1="20" y1="8" x2="20" y2="14" />
                <line x1="23" y1="11" x2="17" y2="11" />
              </svg>
              <span>Invite Member</span>
            </button>
          </div>
        )}
      </div>

      {/* STATS */}
      <div className="stats-strip">
        {stats.map((item) => (
          <div key={item.key || item.label} className="stat-card">
            <div className="stat-card-val">{item.value ?? 0}</div>
            <div className="stat-card-lbl">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

HeaderOverview.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  onInvite: PropTypes.func,
  canManage: PropTypes.bool,
};

export default memo(HeaderOverview);
